export default "__VITE_ASSET__CpexA8mU__"